import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { pipe } from '@effect/data/Function';
import { Box, styled } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { useLocation } from 'react-router-dom';
import { UnknownBlockList } from '../../unknown-block-list';
import { parseUuidFromPath } from './parse-uuid-from-path';
import { useEntityBannerImage } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";

var createBannerFailure = function createBannerFailure(message) {
  return DE.failure(message);
};

var BannerImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var EntityBannerBlock = function EntityBannerBlock(_ref) {
  var fallback = _ref.block.fallback,
      href = _ref.href,
      leafBlocks = _ref.leafBlocks;
  return pipe(useLocation().pathname, parseUuidFromPath, function (uuid) {
    return {
      uuid: uuid,
      // eslint-disable-next-line react-hooks/rules-of-hooks
      bannerImage: useEntityBannerImage({
        variables: {
          id: uuid !== null && uuid !== void 0 ? uuid : ''
        },
        skip: !uuid
      })
    };
  }, function (_ref2) {
    var uuid = _ref2.uuid,
        bannerImage = _ref2.bannerImage;
    return uuid ? bannerImage : createBannerFailure('Did not find a uuid');
  }, DE.map(function (_ref3) {
    var pageBanner = _ref3.entity.pageBanner;
    return pageBanner === null || pageBanner === void 0 ? void 0 : pageBanner.url;
  }), DE.chain(function (url) {
    return url ? DE.success(url) : createBannerFailure('No pageBanner url');
  }), DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        w: 1,
        height: 100
      }
    });
  }, function () {
    return fallback ? /*#__PURE__*/_jsx(UnknownBlockList, {
      blocks: [fallback],
      leafBlocks: leafBlocks,
      href: href
    }) : null;
  }, function (imageUrl) {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        display: {
          xs: 'none',
          md: 'block'
        },
        w: 1
      },
      children: /*#__PURE__*/_jsx(BannerImage, {
        src: imageUrl,
        alt: "Banner"
      })
    });
  }));
};

export default EntityBannerBlock;